<template>
    <BaseForm>
        <template #fields>
            <TextField
                :value="fields.nameShort"
                :label="$t('name-short')"
                :error-messages="errors.nameShort"
                :required="true"
                @input="$emit('onInput', { event: $event, fieldName: 'nameShort' })"
            />
            <TextField
                :value="fields.nameLong"
                :label="$t('name-long')"
                :error-messages="errors.nameLong"
                :required="true"
                @input="$emit('onInput', { event: $event, fieldName: 'nameLong' })"
            />
            <TextField
                :value="fields.intention"
                :label="$t('intention')"
                :error-messages="errors.intention"
                @input="$emit('onInput', { event: $event, fieldName: 'intention' })"
            />
            <TextAreaField
                :value="fields.description"
                :label="$t('description')"
                :error-messages="errors.description"
                @input="$emit('onInput', { event: $event, fieldName: 'description' })"
            />
            <TextField
                :value="fields.kapmanNumber"
                :label="$t('recent-number')"
                :error-messages="errors.kapmanNumber"
                @input="$emit('onInput', { event: $event, fieldName: 'kapmanNumber' })"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import TextField from '@/components/Form/TextField.vue';
import { ScenarioGroupErrors, ScenarioGroupFields } from '@/scenario/types';

defineProps<{ fields: ScenarioGroupFields; errors: ScenarioGroupErrors }>();
defineEmits<{ (e: 'onInput', v: { event: Event; fieldName: string }): void }>();
</script>
